import React from "react";
import { Storage } from "../../../lib/firebase";

// base class
import { BaseComponent } from "shared/components";

// models
import Product from "models/product";

// controllers
import { SizeController, CategoryController } from "controllers";

/**
 * Basic properties for product containers
 */
export default class ProductBaseContainer extends BaseComponent {

    constructor(props) {
        super(props);

        this.seasonSelectRef = React.createRef();
        this.itemFamilyRef = React.createRef();
        this.washingSelectRef = React.createRef();
        this.sizeSelectRef = React.createRef();
        this.colorSelectRef = React.createRef();
        this.brandSelectRef = React.createRef();

        this.state = {
            product: new Product({}),
            beforewashImagesURL: {frontUrl:"", backUrl:""},
            afterwashImagesURL: { frontUrl: "", backUrl: "" },
            isModalVisible: false,
        };

        this.onChange = this.onChange.bind(this);
        this.onChangeItemFamily = this.onChangeItemFamily.bind(this);
        this.onChangeImages = this.onChangeImages.bind(this);
        this.onChangeImagesBF = this.onChangeImagesBF.bind(this);
        this.onChangeImagesBB = this.onChangeImagesBB.bind(this);
        this.onChangeImagesAF = this.onChangeImagesAF.bind(this);
        this.onChangeImagesAB = this.onChangeImagesAB.bind(this);

        this.handleUpload = this.handleUpload.bind(this);
        this.generateLocationCode = this.generateLocationCode.bind(this);

        this.resetState = this.resetState.bind(this);
    }

    onChange(event) {
        const { product } = this.state;

        const { name, value } = event.target;
        product[name] = value;

        if (['size', 'category'].includes(name)) {
            product.location = this.generateLocationCode();
        }

        this.setState({ product });
    }

    onChangeItemFamily(item_family) {
        const { product } = this.state;
        product.item_family = item_family;
        this.setState({ product });
    }

    /**
     * images parameter is an object
     * { file1: [{preview: ..., url: ...}], file2: [{...}], file3: [{...}]}
     */
    onChangeImages(images) {
        const { product } = this.state;

        let cleanedImages = Object.keys(images);
        cleanedImages = cleanedImages.filter((key) => images[key].length > 0)
        product.imageURLs = cleanedImages.map((key) => images[key][0].preview);

        this.setState({
            file: images.file,
            product
        });
    }
    onChangeImagesBF(images) {
        const { product } = this.state;
        
        let cleanedImages = Object.keys(images);
        cleanedImages = cleanedImages.filter((key) => images[key].length > 0)
        product.beforewashImagesURL["frontUrl"] = cleanedImages.map((key) => images[key][0].preview);
        
    
        this.setState((pre)=>({
            beforewashImagesURL: {...pre["beforewashImagesURL"],frontUrl: images.file},
            product
        }));


    }
    onChangeImagesBB(images) {
        const { product } = this.state;
        
        let cleanedImages = Object.keys(images);
        cleanedImages = cleanedImages.filter((key) => images[key].length > 0)
        product.beforewashImagesURL["backUrl"] = cleanedImages.map((key) => images[key][0].preview);
        
    
        this.setState((pre)=>({
            beforewashImagesURL: {...pre["beforewashImagesURL"],backUrl: images.file},
            product
        }));
    }
    onChangeImagesAF(images) {
        const { product } = this.state;
        
        let cleanedImages = Object.keys(images);
        cleanedImages = cleanedImages.filter((key) => images[key].length > 0)
        product.afterwashImagesURL["frontUrl"] = cleanedImages.map((key) => images[key][0].preview);
        
    
        this.setState((pre)=>({
            afterwashImagesURL: {...pre["afterwashImagesURL"],frontUrl: images.file},
            product
        }));
    }
    onChangeImagesAB(images) {
        const { product } = this.state;
        
        let cleanedImages = Object.keys(images);
        cleanedImages = cleanedImages.filter((key) => images[key].length > 0)
        product.afterwashImagesURL["backUrl"] = cleanedImages.map((key) => images[key][0].preview);
        
    
        this.setState((pre)=>({
            afterwashImagesURL: {...pre["afterwashImagesURL"],backUrl: images.file},
            product
        }));
    }

    resetState = () => {
        this.setState({
            product: new Product({}),
            file: [],
            csv_files: [],
            zip_files: [],
        });

        this.seasonSelectRef.current.resetState();
        this.itemFamilyRef.current.resetState();
        this.washingSelectRef.current.resetState();
        this.sizeSelectRef.current.resetState();
        this.colorSelectRef.current.resetState();
        this.brandSelectRef.current.resetState();
    };

    async handleUpload(file, barcode) {

        if (!file.base64) {
            return file.url;
        }

        const stringData = file.base64.split(",");
        await Storage.ref(`products/${barcode}/${file.name}`).putString(
            stringData[1],
            "base64"
        );

        const url = await Storage.ref(`products/${barcode}`)
            .child(file.name)
            .getDownloadURL();
        return url;
    };

    generateLocationCode() {
        const { product } = this.state;

        const size = SizeController.getSizeByValue(product.size)
        const category = CategoryController.getCategoryByValue(product.category);

        return size.code + category.code;
    };
}
